import { AbsoluteFill, useCurrentFrame } from "remotion";
import { HookFrame } from "./HookFrame";
import type { HookPattern } from "./hookTiming";

export const HookPrototype = ({ pattern }: { pattern: HookPattern }) => (
  <AbsoluteFill>
    <HookFrame pattern={pattern} frame={useCurrentFrame()} />
  </AbsoluteFill>
);
